import { EntityMeta, GenerateSummaryResponse, Note } from '@qtek/shared/models';

/** Params of a subscription's list query, replayed to re-fetch the enriched rows. */
export interface NoteQueryParams {
  prms?: Record<string, string>;
  view?: string;
}

export interface NoteState {
  notes: Record<string, Note[]>;
  notesQueryParams: Record<string, NoteQueryParams>;
  notesMeta: EntityMeta;
  notesLoading: boolean;
  aiSummaryResponse: GenerateSummaryResponse | null;
  aiSummaryLoading: boolean;
  aiSummaryFinalizeLoading: boolean;
}

export const noteInitialState: NoteState = {
  notes: {},
  notesQueryParams: {},
  notesMeta: new EntityMeta(),
  notesLoading: false,
  aiSummaryResponse: null,
  aiSummaryLoading: false,
  aiSummaryFinalizeLoading: false,
};

export function addNote(
  state: NoteState,
  mysid: string,
  note: Note
): Pick<NoteState, 'notes'> {
  return {
    notes: {
      ...state.notes,
      [mysid]: [...(state.notes[mysid] ?? []), note],
    },
  };
}

export function replaceNote(
  state: NoteState,
  mysid: string,
  note: Note
): Pick<NoteState, 'notes'> {
  const list = state.notes[mysid] ?? [];
  return {
    notes: {
      ...state.notes,
      [mysid]: list.map(n => (n._id === note._id ? note : n)),
    },
  };
}

export function removeNote(
  state: NoteState,
  mysid: string,
  id: string
): Pick<NoteState, 'notes'> {
  return {
    notes: {
      ...state.notes,
      [mysid]: (state.notes[mysid] ?? []).filter(n => n._id !== id),
    },
  };
}
